module.exports = __webpack_public_path__ + "static/img/point.c967954.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s32/pop/point.png
// module id = LZg6
// module chunks = 2